import { Request, Response } from "express"

import getUser from "#services/auth"

export const routeAuthPost = async (req: Request, res: Response) => {
	// request body is undefined
	const user = await getUser({
		userID: req.body.userName,
		password: req.body.password,
	})

	if (user === null) {
		res.status(401).json({})
	} else {
		res.json(user)
	}
}
